export const CJotFormEmbedFragments = {
  customComponentsLandingPageBlock: `
    fragment customComponentsLandingPage_jotFormEmbed on customComponentsLandingPage_jotFormEmbed_Entry {
      typeHandle
      heading
      introCopy
      formId
    }
  `,
}
